import { ProductCompareCarouselStyles } from "@insite/content-library/Widgets/ProductCompare/ProductCompareCarousel";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

ProductCompareCarouselStyles.headerText = {
    variant: "h2",
    forwardAs: "h1",
    css: css`
           ${({ theme }) => {
            return breakpointMediaQueries(theme, [
                css`
                    padding-left: 20px;
                `,
                css`
                    padding-left: 20px;
                `,
                css``,
                css``,
                css``,
            ]);
        }}
    `,
};
ProductCompareCarouselStyles.headerRemoveAllButton = {
    css: css`
        margin-right: 20px;
    `,
};
ProductCompareCarouselStyles.removeProductFromCompareClickable = {
    css: css`
        position: absolute;
        right: 10px;
    `,
};